import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import loadScript from '../../utils/loadScript'

const createMarkup = __html => ({ __html })

const StyledHtmlContent = styled.div`
  padding: 16px 0 0;

  .chat-embed {
    height: 500px;
    width: 100%;
  }

  ${({ theme }) => theme.media.tablet} {
    .webinar-embed {
      height: 300px;
      width: 500px;
    }
  
    .chat-embed {
      height: 500px;
      width: 250px;
    }
  }

  ${({ theme }) => theme.media.desktop} {
    .webinar-embed {
      height: 600px;
      width: 700px;
    }
  
    .chat-embed {
      height: 600px;
      width: 300px;
    }
  }

  span {
    display: block;
    padding: 16px 0;
    text-align: center;
  }

  h4 {
    font-size: 20px;
    text-align: center;
  }
`

class HtmlContent extends React.Component {
  static propTypes = {
    cmsData: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    const { content, javascript = '' } = this.props.cmsData
    this.state = {
      html: createMarkup(content),
      script: javascript,
    }
  }

  componentDidMount() {
    if (this.state.script) {
      loadScript(this.state.script)
    }
  }

  render() {
    return (
      <StyledHtmlContent>
        <div dangerouslySetInnerHTML={this.state.html} />
      </StyledHtmlContent>
    )
  }
}

export default HtmlContent
